import React, { memo, useEffect, useState } from 'react';
import { Link, Prompt, useHistory, useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';

import { Button, Row, Col, Image, NavDropdown, Form } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { toast } from 'react-toastify';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';

import { trackPromise } from 'react-promise-tracker';
import { Desktop, Mobile } from '../../media-queries/mediaQueries';
import Ellipses from '../../../components/Ellipses';
import CustomPageDescriptionForm from './CustomPageDescriptionForm';
import CustomPageContentForm from './CustomPageContentForm';
import Toaster from '../../../components/Toaster';
import ConfirmAlertModal from '../../../components/ConfirmAlertModal/ConfirmAlertModal';

import { crateCustomPage, deleteCustomPageById, getCustomPageById, updateCustomPageById } from '../../../services/custom_page.service';
import { DateConvert } from '../../../utils/TimesheetManagement';
import { htmlDecode, htmlEncode } from '../../../utils/CustomPageManagement';
import { useAuthContext } from '../../../contexts/user-context';
import { validatePermission } from '../../../utils/UserManagement';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

const ManageCustomPages = memo(() =>
{
    const { authUser } = useAuthContext();
    const classes = useStyles();
    const history = useHistory();
    
    const [activeStep, setActiveStep] = useState(0);
    const [compiledForm, setCompiledForm] = React.useState({});

    const { pageId } = useParams();
    const isAddMode = !pageId;
    const [isAPICalled, setIsAPICalled] = useState(false);

    const [customPage, setCustomPage] = useState(null);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showAccessError, setShowAccessError] = useState(false);
    const [isSubmitSuccessful, setisSubmitSuccessful] = useState(false);

    const validationSchema = [
        // validation for step1
        yup.object({
            button_label: yup.string().required('Button Label is required.'),
            page_title: yup.string(),
            access: yup.array().min(1, 'Please select at least one access Level.').required('Access Level is required.').nullable(),
            page_location: yup.string().required('Page Location is required.').nullable(),
        }),
        // validation for step2
        yup.object({
            contentType: yup.string().required('Content Type is required.'),
            content: yup.string().required('Page content is required'),
        }),
    ];

    const currentValidationSchema = validationSchema[activeStep];

    const methods = useForm({
        resolver: yupResolver(currentValidationSchema),
        // shouldUnregister: false,
        mode: 'onChange'
    });

    const { handleSubmit, reset, trigger, formState: { isValid,  isSubmitting, dirtyFields }, watch, } = methods;
    const form = watch();

    const getSteps = () =>
    {
        return ['Page Description', 'Page Content'];
    };
    
    const steps = getSteps();

    const handleNext = async () =>
    {
        const isStepValid = await trigger();
        setShowAccessError(true);
        
        if (isStepValid || isValid)
        {
            switch (activeStep)
            {
                case 0:                    
                    setCompiledForm({ ...compiledForm, one: form });
                    setActiveStep(prevActiveStep => prevActiveStep + 1);
                    break;
                case 1:
                    setCompiledForm({ ...compiledForm, two: form });
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    break;
                default:
                    return null;
            }

        }
    };

    const handleBack = () =>
    {
        if (activeStep > 0)
        {
            setActiveStep(prevActiveStep => prevActiveStep - 1);
            switch (activeStep)
            {
                case 1:
                    setCompiledForm({ ...compiledForm, two: form });
                    break;
                // case 2:
                //   setCompiledForm({ ...compiledForm, three: form });
                //   break;
                default:
                    return "not a valid step";
            }
        }
    };

    const handleReset = () =>
    {
        setActiveStep(0);
        reset({});
        setCompiledForm({
            one: null,
            two: null,
        });
    };
    

    const getStepContent = (stepIndex, formContent) =>
    {
        switch (stepIndex)
        {
            case 0:
                return (
                    <CustomPageDescriptionForm
                        {...{ formContent }}
                        showAccessError={showAccessError}
                    />
                );
            case 1:
                return (
                    <CustomPageContentForm {...{ formContent }} />
                );
            default:
                return 'Unknown stepIndex';
        }
    }
    
    const onSubmitForm = async (data) =>
    {
        try
        {
            const body = data;
            
            if (body.contentType === 'text' || body.contentType === 'html')
            {
                body.content = htmlEncode(body.content);
            }

            const routePath = body.button_label.split(' ').join('-');
            body.route = `/${body.page_location}/${routePath}`.toLocaleLowerCase();
            if (isAddMode)
            {
                const response = await trackPromise(crateCustomPage(body));
                if (response.status === 201)
                {
                    toast.dark(<Toaster
                        icon="notify"
                        message={response.data.message}
                    />);
                    setisSubmitSuccessful(true);
                    history.push(`/settings/viewCustomPage/${response.data.data.customPage._id}`);
                    window.location.reload();
                }
            }
            else
            {
                
                const response = await trackPromise(
                  updateCustomPageById(pageId, body)
                );
                if (response.status === 200)
                {
                    toast.dark(<Toaster
                        icon="notify"
                        message={response.data.message}
                    />);
                    setisSubmitSuccessful(true);
                    history.push(`/settings/viewCustomPage/${response.data.data.customPage._id}`);
                    window.location.reload();
                }
            }
        } catch (error)
        {

            if (error?.response?.status === 400)
            {
                if (error.response.data.data.error.errors.button_label)
                {
                    toast.dark(
                        <Toaster
                            icon="warning"
                            message={`${error.response.data.data.error.errors.button_label.message}`}
                        />,
                        { autoClose: 5000, hideProgressBar: true }
                    );
                }
            }
            else
            {
                toast.dark(
                    <Toaster
                        icon="error"
                        message={error?.response?.data?.message ?? 'Something went wrong!!!'}
                    />
                );
            }
        }
    };

    const onDeleteCustomPage = async () =>
    {
        try
        {
            const response = await trackPromise(deleteCustomPageById(pageId));
            toast.dark(
                <Toaster icon="notify" message={`${response.data.message}`} />,
                { autoClose: 3000, hideProgressBar: true }
            );            
        } catch (error)
        {
            toast.dark(
                <Toaster
                    icon="error"
                    message={error?.response?.data?.message ?? 'Something went wrong!!!'}
                />
            );
        }
        finally
        {
            setShow(false);
            history.replace('/settings/custompages', { forceReload: true });
        }
    };

    async function getCustomPageDetails()
    {
        try
        {
            const response = await trackPromise(getCustomPageById(pageId));
            setCustomPage(response.data.data.customPage);
            const pageObj = response.data.data.customPage;

            let decodedContent = ''
            if (pageObj.contentType === 'text' || pageObj.contentType === 'html')
            {
                decodedContent = htmlDecode(pageObj.content);
                delete pageObj.content;
            }
            
            reset({
                ...pageObj,
                content: pageObj.contentType === 'markup' ? pageObj.content : decodedContent,
            });
            setCompiledForm({
                one: {
                    button_label: pageObj.button_label,
                    page_title: pageObj.page_title,
                    access: pageObj.access,
                    page_location: pageObj.page_location,
                },
                two: {
                    contentType: pageObj.contentType,
                    content: pageObj.contentType === 'markup' ? pageObj.content : decodedContent,
                },
            });
            setIsAPICalled(true);
        } catch (error)
        {
            toast.dark(
                <Toaster
                    icon="error"
                    message={error?.response?.data?.message ?? 'Something went wrong!!!'}
                />
            );
        }
    }

    useEffect(() =>
    {
        if (!isAddMode)
        {
            getCustomPageDetails();
        }
        else
        {
            setIsAPICalled(true);
        }
    }, [isAddMode]);

    // useEffect(() =>
    // {
    //     console.log({ form, errors });        
    // }, [form, errors]);

    const SettingsDropdown = () =>
    {
        return (<div>
            <NavDropdown
                title={<Ellipses />}
                id="collasible-nav-dropdown"
            >
                <NavDropdown.Item
                    onClick={handleShow}
                    disabled={!validatePermission(authUser.user.role.permissions, 'custom_page', 'edit')}
                >Delete</NavDropdown.Item>
            </NavDropdown>
        </div>);
    };

    return isAPICalled ? (
        <div>
            <div className=" sticky-page-header">
            <div className="container">
                <Desktop>
                    <Row className="ml-5">
                        <Col md="1">
                            <Link to='/settings/custompages'>
                                <a>
                                    <Image
                                        className="imageArrow"
                                        src={`${process.env.PUBLIC_URL}/assets/svg-icons/icon-down-arrow.svg`}
                                        fluid
                                    />
                                </a>
                            </Link>
                        </Col>
                        <Col md="8">
                            {
                                isAddMode ? (
                                    <h5 className="mt-1"><strong>Untitled Page</strong></h5>
                                ) : (
                                    <>
                                        <h5 className="mb-0"><strong>Edit Custom Page</strong></h5>
                                        <label className="txt-light-secondary mb-0">Last Updated on {DateConvert(customPage.updatedAt)}</label>
                                    </>
                                )
                            }
                        </Col>
                        <Col md="1" className="pr-0 ml-5">
                            <Button variant="default" className="btn-ftc-border-primary"
                                onClick={handleReset}
                            >
                                Reset
                            </Button>
                        </Col>
                        {
                            !isAddMode ? (
                                <Col md="1">
                                    <div  className="ml-0">
                                        <SettingsDropdown />
                                    </div>
                                </Col>
                            ) : ('')
                        }
                        
                    </Row>
                </Desktop>
                <Mobile>
                    <div className="container">
                        <Row className="pb-1">
                            <Col xs="1" className="p-0">
                                <Link to="/settings/custompages">
                                    <Image
                                        className="imageArrowMobile mt-1"
                                        src={`${process.env.PUBLIC_URL}/assets/svg-icons/icon-down-arrow.svg`}
                                        fluid
                                    />
                                </Link>
                            </Col>
                            <Col xs="8" className="mt-1">
                                {
                                    isAddMode ? (
                                        <h6 className="mt-0"><strong>Untitled Page</strong></h6>
                                    ) : (
                                        <>
                                            <h5 className="mb-0"><strong>Edit Custom Page</strong></h5>
                                            <p className="txt-light-secondary mx-auto mb-1">
                                                Last Updated on {DateConvert(customPage.updatedAt)}
                                            </p>
                                        </>
                                    )
                                }
                            </Col>
                            <Col xs="1">
                                <Image
                                    onClick={handleReset}
                                    className="ftc-logo-24  mt-1"
                                    src={`${process.env.PUBLIC_URL}/assets/svg-icons/icon-reset.svg`}
                                />
                            </Col>
                            {
                                !isAddMode ? (
                                    <Col xs="1">
                                        <div>
                                            <SettingsDropdown />
                                        </div>
                                    </Col>
                                ) : ('')
                            }
                            
                        </Row>
                    </div>
                </Mobile>
            </div>
            </div>
            <Desktop>
                <div className="container-top-5" />
            </Desktop>
            <Mobile>
                <div className="container-top-20" />
            </Mobile>
            <div className="container">
                <Row>
                    <Col md="8" className="mx-auto">
                        <Stepper activeStep={activeStep}>
                            {steps.map((label) =>
                            {
                                const stepProps = {};
                                const labelProps = {};
                                // if (isStepOptional(index)) {
                                //     labelProps.optional = <Typography variant="caption">Optional</Typography>;
                                // }                                
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                        <div>
                            {/* {activeStep === steps.length ? (
                                <div>
                                    <Typography className={classes.instructions}>
                                        All steps completed - you&apos;re finished
                                    </Typography>
                                    <Button onClick={handleReset} className={classes.button}>
                                        Reset
                                    </Button>
                                </div>
                            ) : ( */}
                            <FormProvider {...methods}>
                                <Form>
                                    <div>
                                        <Typography className={classes.instructions}>
                                            {getStepContent(activeStep, compiledForm)}
                                        </Typography>
                                        <div>
                                            {/* <button type="button" disabled={activeStep === 0} onClick={handleBack} className={`${classes.button} btn btn-ftc-border-primary`} >
                                                Back
                                        </button> */}
                                            {activeStep !== 0 ? (
                                                <Button
                                                    variant="default"
                                                    disabled={activeStep === 0}
                                                    onClick={handleBack}
                                                    className="btn-ftc-border-primary"
                                                >
                                                    Back
                                                </Button>
                                            ) : (
                                                ''
                                            )}

                                            {activeStep === steps.length - 1 ? (
                                                <button
                                                    type="button"
                                                    className={`${classes.button} float-right btn btn-ftc-primary`}
                                                    onClick={handleSubmit(onSubmitForm)}
                                                    disabled={isSubmitting}
                                                // type="submit"
                                                >
                                                    Submit
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={handleNext}
                                                    className={`${classes.button} float-right btn btn-ftc-primary`}
                                                >
                                                    Continue
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    {/* )} */}
                                </Form>
                            </FormProvider>
                        </div>
                    </Col>
                </Row>
            </div>
            {show && <ConfirmAlertModal
                show={show}
                handleClose={handleClose}
                title='Delete Custom Page'
                description='Deleting this page will erase all data inside this record.
                    Are you sure you want to delete this Page?'
                callback={onDeleteCustomPage}
                action='Delete it'
                closeAction='Cancel'
            />}

            <Prompt
                when={isSubmitSuccessful ? false : Object.keys(dirtyFields).length}                
                message='You have unsaved changes, are you sure you want to leave?'
            />
        </div>
    ) : ('')
});

export default ManageCustomPages
